import { render, staticRenderFns } from "./Source.vue?vue&type=template&id=1e80774a&scoped=true"
import script from "./Source.vue?vue&type=script&lang=js"
export * from "./Source.vue?vue&type=script&lang=js"
import style0 from "./Source.vue?vue&type=style&index=0&id=1e80774a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e80774a",
  null
  
)

export default component.exports